<template>
  <div
    :class="$style.gridLayout"
    class="grid gap-8"
  >
    <FilterSelect @changeFilter="fetchArticles"/>
    <Item
      v-for="article in articles"
      :key="article.id"
      :article="article"
      :disciplines="articleDisciplines(article)"
      :tags="articleTags(article)"
    />
  </div>
</template>

<script>
import Pluralize from 'pluralize'
import { Resource, Type } from '@/src/server/helpers/constants'
import FilterSelect from '@/src/server/components/shared/FilterSelect'
import Item from './Item'

export default {
  components: {
    FilterSelect,
    Item,
  },

  data () {
    return {
      articles: [],
      disciplines: [],
      tags: [],
    }
  },

  computed: {
    manager () {
      return this.$route.query.manager
    },
    filter () {
      const [type, id] = (this.$route.query.only || '').split(':')
      const availableFilters = [
        Type.DISCIPLINE,
        Type.TAG,
      ]

      if (id && availableFilters.includes(type)) {
        return { type, id }
      }
    },
    articlesAmount () {
      return Math.max(1, Math.min(50, this.$route.query.amount || 6))
    },
  },

  created () {
    this.fetchArticles(this.filter)
  },

  methods: {
    articleDisciplines (article) {
      return article.relationships.disciplines.data.map((data) => {
        return this.disciplines
          .find((discipline) => discipline.id === data.id)
      })
    },
    articleTags (article) {
      return article.relationships.tags.data.map((data) => {
        return this.tags
          .find((tag) => tag.id === data.id)
      })
    },
    fetchArticles (filter = undefined) {
      if (this.manager) {
        const options = {
          params: {
            query: `${Type.MANAGER}.id = "${this.manager}"`,
            page: {
              size: this.articlesAmount,
            },
            sort: '-published_at',
            include: [
              Resource.DISCIPLINE,
              Resource.TAG,
            ].join(','),
          },
        }

        if (filter) {
          const relationship = Pluralize.plural(filter.type)

          options.params.query += ` AND ${relationship}.id = "${filter.id}"`
        }

        this.$axios(Resource.ARTICLE, options)
          .then((response) => {
            this.articles = response.data.data
            const included = response.data.included || []

            this.disciplines = included
              .filter((included) => included.type === Type.DISCIPLINE)
            this.tags = included
              .filter((included) => included.type === Type.TAG)
          })
      }
    },
  },
}
</script>

<style lang="scss" module>
.grid-layout {
  grid-template-columns: repeat(auto-fill, minmax(calc(var(--font-size) * 22), 1fr));
}
</style>



// WEBPACK FOOTER //
// src/server/components/Articles/Widget.vue